/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 剧院会员注册
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  theaterRegisterDto: member.TheaterRegisterDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/theater-member/register`,
    data: theaterRegisterDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
